import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchElementAnnotations} from './../actions';
import {FormattedMessage} from 'react-intl';
import {annotationRoute} from '../../../constants/public-routes';
import Link from '../../routing/components/Link';
import {getSortedAnnotations} from '../selectors';
import OrderedAnnotations from "../components/OrderedAnnotations";

class AnnotationsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  fetchIfNeeded(props) {
    let {elementAnnotations, elementId, fetchElementAnnotations} = props;
    if (elementAnnotations.element === null) {
      fetchElementAnnotations(elementId);
    }
    else if ((elementAnnotations.elementId !== elementId) && !elementAnnotations.isFetching) {
      fetchElementAnnotations(elementId);
    }
  }

  render() {
    let {orderedAnnotations, params} = this.props;
    return (<OrderedAnnotations annotations={orderedAnnotations} annoLink={(id => {
      return (<Link url={annotationRoute(params, id)} className="btn btn-link btn-sm"><FormattedMessage id="readOn"/></Link>);
    })}/>);
  }
}

AnnotationsContainer.propTypes = {
  fetchElementAnnotations: PropTypes.func.isRequired,
  orderedAnnotations: PropTypes.array.isRequired,
  categoryOrder: PropTypes.array.isRequired,
  elementId: PropTypes.string.isRequired,
  params: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  const {elementAnnotations, element} = state;
  const {elementId} = ownProps.params;
  let categoryOrder = (element && element.item && element.item.attributes && element.item.attributes.categories) ? element.item.attributes.categories : [];
  let orderedAnnotations = getSortedAnnotations(elementAnnotations.item, [elementId], categoryOrder);
  return {
    orderedAnnotations,
    elementId,
    elementAnnotations,
    categoryOrder
  };
}

function mapDispatchToProps(dispatch) {
  return {fetchElementAnnotations: bindActionCreators(fetchElementAnnotations, dispatch)};
}

export default connect(mapStateToProps, mapDispatchToProps)(AnnotationsContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/annotations/containers/AnnotationsContainer.js
 **/